var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1568,
    height: 992,
    viewBox: "0 0 1568 992",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8238_53740",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1568,
    height: 992
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16343 7.16344 0 16 0H1552C1560.84 0 1568 7.16344 1568 16V976C1568 984.837 1560.84 992 1552 992H16C7.16344 992 0 984.837 0 976V16Z",
    fill: "#EEF4FB"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8238_53740)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-56 0H1568V1666H-56V0Z",
    fill: "url(#paint0_linear_8238_53740)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.123233
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.5 451.928C317.926 447.641 327.074 447.641 334.5 451.928L394.071 486.322C401.497 490.609 406.071 498.532 406.071 507.106V575.894C406.071 584.468 401.497 592.391 394.071 596.678L334.5 631.072C327.074 635.359 317.926 635.359 310.5 631.072L250.929 596.678C243.503 592.391 238.929 584.468 238.929 575.894V507.106C238.929 498.532 243.503 490.609 250.929 486.322L310.5 451.928Z",
    fill: "url(#paint1_linear_8238_53740)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.123233
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1236.5 210.928C1243.93 206.641 1253.07 206.641 1260.5 210.928L1320.07 245.322C1327.5 249.609 1332.07 257.532 1332.07 266.106V334.894C1332.07 343.468 1327.5 351.391 1320.07 355.678L1260.5 390.072C1253.07 394.359 1243.93 394.359 1236.5 390.072L1176.93 355.678C1169.5 351.391 1164.93 343.468 1164.93 334.894V266.106C1164.93 257.532 1169.5 249.609 1176.93 245.322L1236.5 210.928Z",
    fill: "url(#paint2_linear_8238_53740)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.123233
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203 611.928C210.426 607.641 219.574 607.641 227 611.928L345.028 680.072C352.454 684.359 357.028 692.282 357.028 700.856V837.144C357.028 845.718 352.454 853.641 345.028 857.928L227 926.072C219.574 930.359 210.426 930.359 203 926.072L84.9718 857.928C77.5462 853.641 72.9718 845.718 72.9718 837.144V700.856C72.9718 692.282 77.5462 684.359 84.9718 680.072L203 611.928Z",
    fill: "url(#paint3_linear_8238_53740)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.123233
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1392 237.928C1399.43 233.641 1408.57 233.641 1416 237.928L1534.03 306.072C1541.45 310.359 1546.03 318.282 1546.03 326.856V463.144C1546.03 471.718 1541.45 479.641 1534.03 483.928L1416 552.072C1408.57 556.359 1399.43 556.359 1392 552.072L1273.97 483.928C1266.55 479.641 1261.97 471.718 1261.97 463.144V326.856C1261.97 318.282 1266.55 310.359 1273.97 306.072L1392 237.928Z",
    fill: "url(#paint4_linear_8238_53740)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.123233
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.999 347.928C141.425 343.641 150.573 343.641 157.999 347.928L280.357 418.572C287.783 422.859 292.357 430.782 292.357 439.356V580.644C292.357 589.218 287.783 597.141 280.357 601.428L157.999 672.072C150.573 676.359 141.425 676.359 133.999 672.072L11.6406 601.428C4.21499 597.141 -0.359375 589.218 -0.359375 580.644V439.356C-0.359375 430.782 4.215 422.859 11.6406 418.572L133.999 347.928Z",
    fill: "url(#paint5_linear_8238_53740)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.226981
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546 9.23761C555.901 3.52136 568.099 3.52135 578 9.2376L787.621 130.262C797.522 135.979 803.621 146.543 803.621 157.975V400.025C803.621 411.457 797.522 422.021 787.621 427.738L578 548.762C568.099 554.479 555.901 554.479 546 548.762L336.379 427.738C326.478 422.021 320.379 411.457 320.379 400.025V157.975C320.379 146.543 326.478 135.979 336.379 130.262L546 9.23761Z",
    fill: "url(#paint6_linear_8238_53740)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.226981
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104 427.238C1113.9 421.521 1126.1 421.521 1136 427.238L1345.62 548.262C1355.52 553.979 1361.62 564.543 1361.62 575.975V818.025C1361.62 829.457 1355.52 840.021 1345.62 845.738L1136 966.762C1126.1 972.479 1113.9 972.479 1104 966.762L894.379 845.738C884.478 840.021 878.379 829.457 878.379 818.025V575.975C878.379 564.543 884.478 553.979 894.379 548.262L1104 427.238Z",
    fill: "url(#paint7_linear_8238_53740)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1111.5 625.196C1117.07 621.981 1123.93 621.981 1129.5 625.196L1202.87 667.554C1208.43 670.769 1211.87 676.712 1211.87 683.142V767.858C1211.87 774.288 1208.43 780.231 1202.87 783.446L1129.5 825.804C1123.93 829.019 1117.07 829.019 1111.5 825.804L1038.13 783.446C1032.57 780.231 1029.13 774.288 1029.13 767.858V683.142C1029.13 676.712 1032.57 670.769 1038.13 667.554L1111.5 625.196Z",
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.5 547.196C380.069 543.981 386.931 543.981 392.5 547.196L465.866 589.554C471.435 592.769 474.866 598.712 474.866 605.142V689.858C474.866 696.288 471.435 702.231 465.866 705.446L392.5 747.804C386.931 751.019 380.069 751.019 374.5 747.804L301.134 705.446C295.565 702.231 292.134 696.288 292.134 689.858V605.142C292.134 598.712 295.565 592.769 301.134 589.554L374.5 547.196Z",
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1208.99 557.481C1212.71 555.328 1217.29 555.328 1221.01 557.481L1247.01 572.534C1250.72 574.679 1253 578.637 1253 582.919V613.081C1253 617.363 1250.72 621.321 1247.01 623.466L1221.01 638.519C1217.29 640.672 1212.71 640.672 1208.99 638.519L1182.99 623.466C1179.28 621.321 1177 617.363 1177 613.081V582.919C1177 578.637 1179.28 574.679 1182.99 572.534L1208.99 557.481Z",
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.983 225.641C205.942 222.77 212.058 222.77 217.017 225.641L258.017 249.378C262.958 252.239 266 257.515 266 263.225V310.775C266 316.485 262.958 321.761 258.017 324.622L217.017 348.359C212.058 351.23 205.942 351.23 200.983 348.359L159.983 324.622C155.042 321.761 152 316.485 152 310.775V263.225C152 257.515 155.042 252.239 159.983 249.378L200.983 225.641Z",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8238_53740",
    x1: -56,
    y1: 1666,
    x2: 1568,
    y2: 1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017ADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A268E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8238_53740",
    x1: 446.841,
    y1: 485.72,
    x2: 263.228,
    y2: 411.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8238_53740",
    x1: 1372.84,
    y1: 244.72,
    x2: 1138,
    y2: 330,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#1CD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8238_53740",
    x1: 237,
    y1: 913,
    x2: 137,
    y2: 648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8238_53740",
    x1: 1184,
    y1: 435,
    x2: 1553,
    y2: 296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD3FF",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8238_53740",
    x1: 363.757,
    y1: 412.312,
    x2: 42.1953,
    y2: 281.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8238_53740",
    x1: 921.495,
    y1: 117.729,
    x2: 390.632,
    y2: -97.5351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8238_53740",
    x1: 853,
    y1: 768,
    x2: 1379,
    y2: 543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD3FF",
    stopOpacity: 0.49
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.058c17915f0b24f3c5598eacf2450aba.svg";
export { ForwardRef as ReactComponent };